var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryInlinePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H31.5V39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.34 22.2533C20.52 22.2533 19.7267 22.12 18.9867 21.88C18.7533 21.8 18.4933 21.86 18.3133 22.04L17.2667 23.3533C15.38 22.4533 13.6133 20.7533 12.6733 18.8L13.9733 17.6933C14.1533 17.5067 14.2067 17.2467 14.1333 17.0133C13.8867 16.2733 13.76 15.48 13.76 14.66C13.76 14.3 13.46 14 13.1 14H10.7933C10.4333 14 10 14.16 10 14.66C10 20.8533 15.1533 26 21.34 26C21.8133 26 22 25.58 22 25.2133V22.9133C22 22.5533 21.7 22.2533 21.34 22.2533Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryInlinePhone);
export default __webpack_public_path__ + "static/media/Primary_Inline_Phone.ed8126929941db1a60a9278eb21c54e4.svg";
export { ForwardRef as ReactComponent };